import { useEffect, useState } from "react";
import { funcionarioService } from "../../../../pages/colaborador/service/funcionario.service";
import { SelectField } from "../../ui";

interface SelectFuncionariosProps {
  value: string;
  onChange: (id: string, name?: string) => void;
  idObra?: string;
  idSector: string;
  required?: boolean;
  disabled?: boolean;
}

interface ColaboradorOption {
  id: string;
  fullName: string;
  corporateName?: string;
  fantasyName?: string;
  idWork: string;
  idSector: string;
  active: boolean;
}

export function SelectFuncionarios({
  value,
  onChange,
  idObra,
  idSector,
  required = false,
  disabled = false,
}: SelectFuncionariosProps) {
  const [colaborador, setColaborador] = useState<ColaboradorOption[]>([]);
  const [colaboradorPorSetor, setColaboradorPorSetor] = useState<
    ColaboradorOption[]
  >([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await funcionarioService.select();

      setColaborador(
        data.filter(
          (colab: ColaboradorOption) =>
            colab.idSector == idSector && colab.active
        )
      );
    };
    fetchData();
  }, [idSector]);


  useEffect(() => {
    let filtrados = colaborador;
    if (idObra) {
      filtrados = filtrados.filter((colab) => colab.idWork === idObra);
    }
    setColaboradorPorSetor(filtrados);
  }, [colaborador, idObra]);

  return (
    <SelectField
      label="Selecione um Colaborador"
      value={value || ""}
      onChange={(e) => {
        const funcionarioSelecionado = colaboradorPorSetor.find(
          (f) => f.id === e.target.value
        );
        const nome =
          funcionarioSelecionado?.corporateName ||
          funcionarioSelecionado?.fullName ||
          funcionarioSelecionado?.fantasyName ||
          "";
        onChange(e.target.value, nome);
      }}
      required={required}
      disabled={disabled}
    >
      {colaboradorPorSetor.length > 0 ? (
        <>
          <option value="" />
          {colaboradorPorSetor.map((funcionario) => (
            <option key={funcionario.id} value={funcionario.id}>
              {funcionario.corporateName ||
                funcionario.fullName ||
                funcionario.fantasyName}
            </option>
          ))}
        </>
      ) : (
        <option disabled value="">
          Nenhum colaborador disponível para a configuração selecionada.
        </option>
      )}
    </SelectField>
  );
}
